export default "__VITE_ASSET__x7XhrEjo__"